export const subtitles = {
    "1": {
        "startTime": 0.67,
        "endTime": 7.32,
        "transcript": "Akluit-llu eru'urqamteki angutet akluit allakarcetetullruit aanamta",
        "translation": "And when we washed their clothes, our mothers would have us separate the men's clothes"
    },
    "2": {
        "startTime": 7.32,
        "endTime": 13.76,
        "transcript": "Wangkuta-llu arnani akluput allakartelluki, tua-i kencikngamegteki.",
        "translation": "And they had us separate us women's clothes, because they greatly respected them."
    },
    "3": {
        "startTime": 13.765,
        "endTime": 19.88,
        "transcript": "Waten man'a ava-i qanrutkurallerci pissuryaraq pitekluku pitullruut.",
        "translation": "They used to do that because of the hunting that you just talked about."
    },
    "4": {
        "startTime": 19.88,
        "endTime": 27.94,
        "transcript": "Arnam aklui allakarmeng iqairumaarkauluteng, arnartarrlainaat.",
        "translation": "A woman's clothes must be washed separately, only women's clothes [together]."
    },
    "5": {
        "startTime": 27.945,
        "endTime": 35.26,
        "transcript": "Atullruaqa-llu wiinga. Tua-i atutuaqa tan'gaurlurugarnek-llu irniangqerrama.",
        "translation": "I also did that. I do it because I have many male children."
    },
    "6": {
        "startTime": 35.26,
        "endTime": 44.95,
        "transcript": "Tua-i-llu ukut wani angutem aklui mermun tuavet arnat iqairitellratnun pivkenaki.",
        "translation": "And, we don't put the men's clothes into that water used to wash the women's clothes."
    },
    "7": {
        "startTime": 45.18,
        "endTime": 51.68,
        "transcript": "Uum wani nutaan nutaramek imirluki angutem pii piarkautullruut.",
        "translation": "They would have to fill them with fresh water to wash the men's clothes."
    },
    "8": {
        "startTime": 51.685,
        "endTime": 58.515,
        "transcript": "Ayuqucirtutullruitkut waten: ilarqutevkenaki aulukesqelluki qigcikluki.",
        "translation": "They would instruct us like this: not to take care of them altogether out of respect."
    },
    "9": {
        "startTime": 58.515,
        "endTime": 63.31,
        "transcript": "Cam iliini aptua, \"Ciin waten pivkalarciki?\"",
        "translation": "One day, I asked, \"Why do you have them [washed] like this?\""
    },
    "10": {
        "startTime": 63.31,
        "endTime": 67.1,
        "transcript": "Aanamnun aptetullruunga nallukemnek.",
        "translation": "I used to ask my mother about what I didn't know."
    },
    "11": {
        "startTime": 67.1,
        "endTime": 69.67,
        "transcript": "Tua-ll' waten aanama pianga:",
        "translation": "Then my mother said this to me:"
    },
    "12": {
        "startTime": 69.67,
        "endTime": 81.4,
        "transcript": "Waten-gguq ava-i qanrutkurallerpecicetun wanirpak pissullerkaat, pitengnaqlerkaat yuilqumi pitekluku tuaten pimaut makut.",
        "translation": "She said, as you've been speaking about now, that they do that for their hunting, so that they will be good at catching animals in the wilderness."
    },
    "13": {
        "startTime": 81.4,
        "endTime": 88.22,
        "transcript": "Taringellemnek maa-i qaneryuglua qanertua sassairutqatalliniamegnuk.",
        "translation": "I've said what I wanted to say about what I understood since we're almost out of time."
    },
    "14": {
        "startTime": 88.22,
        "endTime": 99.15,
        "transcript": "Tua-i-llu wangkuta arnani neqnek aulukilriani tua-i qigcikluki angutet unangkengait.",
        "translation": "Then we women who took care of food would treat what the men obtained with respect."
    },
    "15": {
        "startTime": 99.15,
        "endTime": 105.95,
        "transcript": "Melqulgungraata, caungraata tua-i angutet unakellrit qigcikluki aulukellruaput.",
        "translation": "Whether fur-bearing animals, no matter what they we were, we took care of what men obtained with respect."
    },
    "16": {
        "startTime": 106.535,
        "endTime": 111.175,
        "transcript": "Tamana tua-i alerquun atungnaqu'urluku.",
        "translation": "We tried to practice that instruction."
    },
    "17": {
        "startTime": 111.47,
        "endTime": 115.09,
        "transcript": "Uqlaulluki pillrunritaput.",
        "translation": "We didn't make a mess of them."
    },
    "18": {
        "startTime": 115.095,
        "endTime": 125.185,
        "transcript": "Pitaita enrit, carrluit, iluita-llu carrillrit uqlaulluki aulukellrunritaput.",
        "translation": "We didn't make a mess of the bones, the craps, and the guts of what they caught as we took care of them."
    },
    "19": {
        "startTime": 125.475,
        "endTime": 133.585,
        "transcript": "Ca tamalkuan apyutektullruaqa aanmanun, aanamni-wa tua-i irniaruama kiima.",
        "translation": "I would ask my mother about everything, because I was my mother's only child."
    },
    "20": {
        "startTime": 134.085,
        "endTime": 138.54,
        "transcript": "Ilarugailama apyutketullruanka.",
        "translation": "Since I didn't have a lot of relatives, I would ask about them."
    },
    "21": {
        "startTime": 138.54,
        "endTime": 141.86,
        "transcript": "Tua-ll' waten pitullruanga:",
        "translation": "Then she would say this to me:"
    },
    "22": {
        "startTime": 142.185,
        "endTime": 150.355,
        "transcript": "Ava-i uqlaupakaqumki-gguq tamakut pitai uum aiparma",
        "translation": "She said that if I make a mess of what my spouse caught too much"
    },
    "23": {
        "startTime": 150.355,
        "endTime": 155.345,
        "transcript": "Tauna-gguq nakriaruciiquq, yuilqumek-llu pit'qerciigaliluni.",
        "translation": "She said he will become unlucky in hunt, and won't be able to catch anything in the wilderness anymore."
    },
    "24": {
        "startTime": 155.345,
        "endTime": 162.215,
        "transcript": "Tua-i-gguq-wa uqlaulluki wiinga tuaten tua-i piciqellriit uqlauskumki.",
        "translation": "She said that will happen if I make a mess of them."
    },
    "25": {
        "startTime": 162.215,
        "endTime": 166.61,
        "transcript": "Pitarkam pinrirluku.",
        "translation": "Animals he hunts will not give themselves."
    },
    "26": {
        "startTime": 166.61,
        "endTime": 174.44,
        "transcript": "Tua-i-ll' ukvekluki wiinga. Ukvektullruluki tamakut tuaten pitullinilriit.",
        "translation": "And I believed them. I believed that happens to them."
    },
    "27": {
        "startTime": 174.86,
        "endTime": 181.1,
        "transcript": "Cali-llu ava-i qanellruunga",
        "translation": "I also just said"
    },
    "28": {
        "startTime": 182.275,
        "endTime": 191.61,
        "transcript": "Pingnaquralput arnani uitaurayuilamta, yuilqumek pingnaquratuamta piyararrarluta-llu pitullruluta.",
        "translation": "Since we women who subsist are not sedentary, since we try to gather from the wilderness, we also had practices."
    },
    "29": {
        "startTime": 191.61,
        "endTime": 202.14,
        "transcript": "Qigcikluku yuum pivianun, yuum piyaraanun pisqumamayuitellruukut.",
        "translation": "Out of respect, we would be told not to go to a person's place, a person's gathering place."
    },
    "30": {
        "startTime": 202.14,
        "endTime": 210.09,
        "transcript": "Taum-wa yuum tauna piyaraqngaku qigcignaqluni umyugaan nall'artenritlerkaa.",
        "translation": "Since it was that person's gathering place, it required respect so as not to offend them."
    },
    "31": {
        "startTime": 211.15,
        "endTime": 218.18,
        "transcript": "Tua-i pivimteńun taug͡aam wangkuta pingnaquratullruukut, piciatun pivkenata.",
        "translation": "We would only go to our spots, not in any random place."
    },
    "32": {
        "startTime": 218.77,
        "endTime": 225.31,
        "transcript": "Tua-i-llu cali niitetullrulua qalartellrianek",
        "translation": "I also used to hear people giving instruction"
    },
    "33": {
        "startTime": 225.495,
        "endTime": 230.375,
        "transcript": "Angutet-gguq makut pissurtet pissulriit",
        "translation": "These men who hunt"
    },
    "34": {
        "startTime": 231.19,
        "endTime": 242.37,
        "transcript": "Canek aruarkanek, tuani-llu taluyam nuniini, kuvyam-llu nuniini aruarkanek piyuitut.",
        "translation": "Things that will spoil, they do not put anything that will spoil there in the fish trapping spot, and drift netting spot."
    },
    "35": {
        "startTime": 247.125,
        "endTime": 260.145,
        "transcript": "Tauna-gguq kuvyiryaraq neqem aruvikellrukani, allrakuani nurciarkauguq neqmek.",
        "translation": "They said that if a fish spoils in that drift netting spot, the fish will be low the next year."
    },
    "36": {
        "startTime": 260.37,
        "endTime": 264.29,
        "transcript": "Pitangqerrngaunani tuaten amllertalriamek.",
        "translation": "There will not be that many [like the year before]."
    },
    "37": {
        "startTime": 264.295,
        "endTime": 271.125,
        "transcript": "Tauna-llu cali taluyaq pissuun, kuicuarmi tuani civingalria",
        "translation": "And that implement, the fish trap that is set there in a creek"
    },
    "38": {
        "startTime": 271.125,
        "endTime": 276.335,
        "transcript": "Kuicuar-gguq tamana cali pissurvikestiin kencikaa.",
        "translation": "They said the person who subsists in that creek reveres it."
    },
    "39": {
        "startTime": 276.335,
        "endTime": 281.305,
        "transcript": "Aruiviksuumiitaa elliin pissuryaraqngamiu.",
        "translation": "He doesn't want anything to spoil there because he subsists there."
    },
    "40": {
        "startTime": 282.015,
        "endTime": 289.425,
        "transcript": "Aruivikumallrukuni-gguq ungungssimek, camek tua-i pitamek taluyat nuniit",
        "translation": "They said that if an animal, or some other thing they caught, spoils around the fish trapping spot"
    },
    "41": {
        "startTime": 289.425,
        "endTime": 295.495,
        "transcript": "Allamiani nakerrluni cali pitangqerrngaituq pissulallratun.",
        "translation": "The next year, it will not be as plentiful as it used to be."
    },
    "42": {
        "startTime": 295.495,
        "endTime": 300.835,
        "transcript": "Tamakut tang wangkuta asgurakellrunrilkeput avani ciuqvaarni.",
        "translation": "You see, we didn't doubt those back then."
    },
    "43": {
        "startTime": 301.18,
        "endTime": 308.47,
        "transcript": "Ca tamalkuan au͡gkut yuut qigcikellruat, yuilqurrungraan nunaungraan-llu.",
        "translation": "People back then respected everything, even the wilderness and even the land."
    },
    "44": {
        "startTime": 308.47,
        "endTime": 316.23,
        "transcript": "Ava-i qanllemtun watua, nunam qainga tangniirupailgan",
        "translation": "As I just said, before the land started looking unpleasant"
    },
    "45": {
        "startTime": 316.235,
        "endTime": 323.465,
        "transcript": "Makunek kalikallernek can-allernek-llu patuvailgan, nunam qainga menuitellruuq.",
        "translation": "Before it was covered with cardboard and empty cans, the land was pristine."
    },
    "46": {
        "startTime": 323.465,
        "endTime": 329.16,
        "transcript": "Nunat-llu nuniit elaqvanun assirluni tangerrnarqetullruuq.",
        "translation": "And the area far out around the villages would look good."
    },
    "47": {
        "startTime": 329.16,
        "endTime": 336.8,
        "transcript": "Mat'um nalliini yuum tekiartellra tamarmi elitaqnarqelartuq.",
        "translation": "These days, you can tell every area that a person came across."
    },
    "48": {
        "startTime": 337.055,
        "endTime": 346.97,
        "transcript": "Una yuum tekitellrullinikii canek-llu egqaqilliniluni, maa-i call' cautellminek, atullminek.",
        "translation": "The place a person had come across, they would throw things, and there are their trash, what they used."
    },
    "49": {
        "startTime": 346.97,
        "endTime": 350.06,
        "transcript": "Mat'um nalliini tuaten nuna ellirtuq.",
        "translation": "These days, the land has become like that."
    },
    "50": {
        "startTime": 350.06,
        "endTime": 353.55,
        "transcript": "Menuitenrirtuq yuilqurtuumarmi.",
        "translation": "It's not pristine anymore, including the wilderness."
    },
    "51": {
        "startTime": 353.55,
        "endTime": 356.6,
        "transcript": "Qigcikenriryugnarqaat.",
        "translation": "I think they don't respect it anymore."
    },
    "52": {
        "startTime": 358.61,
        "endTime": 360.79,
        "transcript": "Tua-i tuaten taktaaqa.",
        "translation": "That's all for that."
    },
    "53": {
        "startTime": 360.795,
        "endTime": 362.355,
        "transcript": "Okay.",
        "translation": "Okay."
    },
    "54": {
        "startTime": 363.22,
        "endTime": 365.44,
        "transcript": "She says that...",
        "translation": "She says that..."
    },
    "55": {
        "startTime": 365.645,
        "endTime": 373.265,
        "transcript": "...naunraat, kuiget, (Nanvat-llu.) nanvat-llu, tamakut.",
        "translation": "...plants, rivers, (And lakes), and lakes, those things."
    },
    "56": {
        "startTime": 377.34,
        "endTime": 380.6,
        "transcript": "Kencikluki, qigcikluki.",
        "translation": "We revered and respected them."
    },
    "57": {
        "startTime": 380.605,
        "endTime": 381.775,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "58": {
        "startTime": 386.165,
        "endTime": 395.185,
        "transcript": "Au͡gkut mat'umi-llu Kuigpagmi, maani Kusquqvagmi, tayima Yukon-ami-llu piciqut",
        "translation": "Back then, here on the Yukon, here on the Kuskokwim, and likely on the Yukon"
    },
    "59": {
        "startTime": 395.199,
        "endTime": 403.849,
        "transcript": "Yuut alerquutengqertut kuigmek mat'umek kencikluku piklerkaanek.",
        "translation": "Yupiit have a traditional instruction to preside over this river with reverence."
    },
    "60": {
        "startTime": 404.043,
        "endTime": 416.056,
        "transcript": "Tua-i-gguq cali wangkutni up'nerkami wall'u kiagmi-llu",
        "translation": "They said that for us, in the spring or in the summer too"
    },
    "61": {
        "startTime": 416.468,
        "endTime": 433.118,
        "transcript": "Imkunek au͡gkunek ciuliamteńek alerquutengqertukut, mat'umun kuigmun kiagaqan kiagcetarnek allragnillarnek neqlernek egcivikesqevkenaku watqapik.",
        "translation": "We have an instruction from our ancestors back then that in the summer, we should never throw white-fronted geese from the summer of the previous year."
    },
    "62": {
        "startTime": 433.137,
        "endTime": 445.025,
        "transcript": "Tua-i-gguq tamakut kiagcetaat tamaani pilallrata tamana neqem nayussiyaagngaitaa.",
        "translation": "They said that when the food from the last summer are thrown there, fish won't stay there."
    },
    "63": {
        "startTime": 445.025,
        "endTime": 456.013,
        "transcript": "Tua-i imkucetun kuiggaarcetun uum qanrutkellracetun tamana taum nunii neqengqerrngaunani elluarrluni.",
        "translation": "Like those creeks that she just spoke of, that area will not have good fish populations."
    },
    "64": {
        "startTime": 456.026,
        "endTime": 463.326,
        "transcript": "Tau͡gaam-gguq kiagcetaat tamakut egtevkenaki mermun tamaavet.",
        "translation": "But they said not to throw those things from the previous summer into that water."
    },
    "65": {
        "startTime": 463.345,
        "endTime": 470.358,
        "transcript": "Elagluku-gguq nuna teq'aqilaput tamaavet alaicetevkenaki-llu.",
        "translation": "They said we should dig and bury them in a pit there, and not have them be visible."
    },
    "66": {
        "startTime": 470.37,
        "endTime": 484.358,
        "transcript": "Tau͡gaam-gguq makut tua-i nutarat neqet iluit, qiluit-llu egtengramteki unavet tau͡gaam tutmararkaunrilngurmun.",
        "translation": "But they said we can throw the guts and intestines of these fresh fish down [in the water], but where people will not trod."
    },
    "67": {
        "startTime": 486.858,
        "endTime": 494.383,
        "transcript": "Kuvesqelluki yuum tutmarngailkiitnun etuuralriamun, entaanrilngurmun-llu.",
        "translation": "They said to dump them in a deep area where people won't trod, and where it doesn't get exposed at low tide."
    },
    "68": {
        "startTime": 494.389,
        "endTime": 506.539,
        "transcript": "Tua-i-am maa-i egciyaurtut mer'em ceńaq tua-i man'a neqngurrluku tamakunek alerquutet maligtaqunrilamegteggu maa-i.",
        "translation": "Now, they've started throwing things, turning the bank into fish [waste], because they don't heed traditional instructions now."
    },
    "69": {
        "startTime": 506.558,
        "endTime": 518.033,
        "transcript": "Tua-i cali tuaten kuigem mat'um un'um kuigpallraam kencikluku atullerkaa tuaten ayuquq wangkutnun.",
        "translation": "That's is how we should reverently treat the river, the huge river down there."
    },
    "70": {
        "startTime": 520.539,
        "endTime": 525.927,
        "transcript": "Okay, as far as the rivers in spring or summer",
        "translation": "Okay, as far as the rivers in spring or summer"
    },
    "71": {
        "startTime": 525.94,
        "endTime": 530.89,
        "transcript": "The rules of their forefathers were that they were told not to throw",
        "translation": "The rules of their forefathers were that they were told not to throw"
    },
    "72": {
        "startTime": 530.909,
        "endTime": 543.259,
        "transcript": "If there should be leftovers that can't be eaten from the winter, that you do not throw these into the river.",
        "translation": "If there should be leftovers that can't be eaten from the winter, that you do not throw these into the river."
    },
    "73": {
        "startTime": 543.266,
        "endTime": 549.228,
        "transcript": "If you do, there's a chance that the new fish will not come to that river.",
        "translation": "If you do, there's a chance that the new fish will not come to that river."
    },
    "74": {
        "startTime": 551.391,
        "endTime": 562.304,
        "transcript": "Au͡gna, au͡gna wani taringecurlagnayukluku nallulriarulaata makut, una-llu waniwa Yaquleyagiurteńek pilria.",
        "translation": "In case they might misunderstand that since they don't know, and this person is from Fish and Game."
    },
    "75": {
        "startTime": 563.816,
        "endTime": 567.491,
        "transcript": "Neqnek wangkuta egcisciigatukut.",
        "translation": "We cannot throw food away."
    },
    "76": {
        "startTime": 567.51,
        "endTime": 572.572,
        "transcript": "Yugmek-llu egcilriamek niiteksaitua man'a engelkarrluku.",
        "translation": "And I haven't heard of a Yup'ik person throwing [food] away to this day."
    },
    "77": {
        "startTime": 572.585,
        "endTime": 579.523,
        "transcript": "Tau͡gaam ellaita ukut qatellriaput neqnek egqaqilartut. Tua-i.",
        "translation": "But the Caucasians among us throw food away. That's all."
    },
    "78": {
        "startTime": 583.898,
        "endTime": 591.173,
        "transcript": "He didn't want any misunderstanding of throwing away.",
        "translation": "He didn't want any misunderstanding of throwing away."
    },
    "79": {
        "startTime": 591.179,
        "endTime": 601.629,
        "transcript": "He's saying that the Native people as a whole are told that you don't throw away food.",
        "translation": "He's saying that the Native people as a whole are told that you don't throw away food."
    },
    "80": {
        "startTime": 601.648,
        "endTime": 608.198,
        "transcript": "He just wanted to make that clear because he doesn't [?] they do that.",
        "translation": "He just wanted to make that clear because he doesn't [?] they do that."
    },
    "81": {
        "startTime": 610.605,
        "endTime": 624.83,
        "transcript": "But he has seen, you know, people, you know, who don't have that kind of rule, throwing fish away, just the way they are.",
        "translation": "But he has seen, you know, people, you know, who don't have that kind of rule, throwing fish away, just the way they are."
    },
    "82": {
        "startTime": 628.336,
        "endTime": 633.486,
        "transcript": "Qigcikekuvgu-gguq ca imna neqngungraan",
        "translation": "If you treat something with respect, even if it's food"
    },
    "83": {
        "startTime": 633.493,
        "endTime": 644.655,
        "transcript": "Qaill'-gguq, iciw' cut-atullruaci qigciklerpeci pitaciatun.",
        "translation": "How, you know, you used to cut them with as much respect as you had."
    },
    "84": {
        "startTime": 644.668,
        "endTime": 650.331,
        "transcript": "Wall'u-gguq-qaa tauna piciatun kepuryuumauq neqa?",
        "translation": "Or can that fish be cut in any way?"
    },
    "85": {
        "startTime": 650.343,
        "endTime": 660.793,
        "transcript": "Makut tamaa neqet wangkutnun cali inerquutekumallruut imumi, tayima-wa tua-i unani-ll' imarpigmiutaat pillilriit.",
        "translation": "We had admonishments concerning fish back then, and it probably also concerns marine animals down there."
    },
    "86": {
        "startTime": 660.812,
        "endTime": 671.887,
        "transcript": "Neqet wangkuta piqertuutamek aturluta kepuusqevkenaki, tau͡gaam uluamek aturluta kepluki urumakata.",
        "translation": "We were told not to cut fish with axes, but to cut them with ulus if they're thawed."
    },
    "87": {
        "startTime": 671.893,
        "endTime": 676.393,
        "transcript": "Tamaa-i tamakutgun tau͡gaam pisqelluki.",
        "translation": "They said to only use those [ulus]."
    },
    "88": {
        "startTime": 676.412,
        "endTime": 684.412,
        "transcript": "Inerquutauluteng piqertuutaq aturluku neqnun taukunun pisqevkenata",
        "translation": "We were admonished against using axes on those fish"
    },
    "89": {
        "startTime": 684.419,
        "endTime": 690.906,
        "transcript": "Kumlaskata tau͡gaam ner'arkaukatki qimugtet maa-i tagumarilriit.",
        "translation": "Unless they're cold, and the dogs who've come on land are going to eat them."
    },
    "90": {
        "startTime": 690.919,
        "endTime": 694.331,
        "transcript": "Kuigmi cali piqertuarluki inerquutekluki.",
        "translation": "They also admonished against using an axe on them in a river."
    },
    "91": {
        "startTime": 694.344,
        "endTime": 705.344,
        "transcript": "Neqa tauna unani wall' Akulmi nugumalria piqertuutarmek kepuusqevkenaku. Inerquutnguluni tua-i tamana.",
        "translation": "They said not to use an axe to cut that fish that's come up down there or in the Akula region. That was an admonishment."
    },
    "92": {
        "startTime": 705.351,
        "endTime": 714.526,
        "transcript": "Tua-i tuaten au͡gna ayuquq, piqertuutaq atuusqumavkenani Akulmi wall' maani-llu.",
        "translation": "That's what that's like, not to use an axe in the Akula region or here."
    },
    "93": {
        "startTime": 714.545,
        "endTime": 719.632,
        "transcript": "Tua-i piqertuarluku tamana cali assikevkenaku.",
        "translation": "They didn't like using axes [on fish]."
    },
    "94": {
        "startTime": 719.645,
        "endTime": 731.332,
        "transcript": "Kelgalarniluki cali, neqairut'larniluku tuaten aulukestemta tangvagaqamikut picuvvlaggluta tuaten pillrit tamakut neqet.",
        "translation": "Our caretakes said they [?inforn other animls], and that there are no more fish there when we are sloppy taking care of those fish."
    },
    "95": {
        "startTime": 731.645,
        "endTime": 734.857,
        "transcript": "Yeah, he has that answer.",
        "translation": "Yeah, he has that answer."
    },
    "96": {
        "startTime": 734.87,
        "endTime": 738.77,
        "transcript": "Eliza, \"piqertuaraqan?\"",
        "translation": "Eliza, \"piqertuaraqan [when he uses an axe]?\""
    },
    "97": {
        "startTime": 738.777,
        "endTime": 739.927,
        "transcript": "Axe.",
        "translation": "Axe."
    },
    "98": {
        "startTime": 739.946,
        "endTime": 742.009,
        "transcript": "Okay, okay.",
        "translation": "Okay, okay."
    },
    "99": {
        "startTime": 742.021,
        "endTime": 750.196,
        "transcript": "There's a way that you cut rather than hitting motion like an axe or whatnot",
        "translation": "There's a way that you cut rather than hitting motion like an axe or whatnot"
    },
    "100": {
        "startTime": 750.202,
        "endTime": 753.902,
        "transcript": "Unless they're frozen and can't be taken any other way.",
        "translation": "Unless they're frozen and can't be taken any other way."
    },
    "101": {
        "startTime": 753.915,
        "endTime": 757.89,
        "transcript": "Then you show respect if it's thawed.",
        "translation": "Then you show respect if it's thawed."
    },
    "102": {
        "startTime": 759.134,
        "endTime": 763.996,
        "transcript": "Neqerrluaraat, neqerrluarnek pilaqeput tua-i dry fish",
        "translation": "Dried fish, dried fish that we call neqerrluaraat"
    },
    "103": {
        "startTime": 764.572,
        "endTime": 772.572,
        "transcript": "Leftover-aarqamta qimugtelegnun tua-i tuntuaput, taumun qimugtelilriamun yugmun.",
        "translation": "When we have leftovers, we give them to someone with dogs, a person with many dogs."
    },
    "104": {
        "startTime": 772.579,
        "endTime": 775.054,
        "transcript": "Tua-i tunluki cikiutekluki.",
        "translation": "We give them as gifts."
    },
    "105": {
        "startTime": 775.073,
        "endTime": 780.635,
        "transcript": "And he also wanted to say that if they have leftover, like with...",
        "translation": "And he also wanted to say that if they have leftover, like with..."
    },
    "106": {
        "startTime": 781.073,
        "endTime": 789.823,
        "transcript": "Cat tua-i ayuqenrilnguut naunraat, au͡gkut-llu berries-aat",
        "translation": "Various plants, and those berries"
    },
    "107": {
        "startTime": 792.617,
        "endTime": 799.817,
        "transcript": "Tua-i-w' unitetuaput iqvalqenrilkeput tau͡gaam atsalingraan, you know, tegumanrilnguut.",
        "translation": "But we leave what we didn't pick though there are a lot of berries, you know, what hasn't been taken."
    },
    "108": {
        "startTime": 799.836,
        "endTime": 806.011,
        "transcript": "Tau͡gaam uniciaqameng aqvaarkauluki atsat.",
        "translation": "When they leave some, they will [return and] get the berries."
    },
    "109": {
        "startTime": 806.555,
        "endTime": 811.442,
        "transcript": "Piyuani pillrukuni pavani atmagluki.",
        "translation": "If one walked inland, they'd carry them on their back."
    },
    "110": {
        "startTime": 811.455,
        "endTime": 819.305,
        "transcript": "Unangliqkuni tua-i uniciqerluni natmun tuavet piarkaunrilngurmun",
        "translation": "If one gets a lot, they will leave them there where they will not be tampered with"
    },
    "111": {
        "startTime": 819.324,
        "endTime": 823.137,
        "transcript": "Nutaan aqvaluki taukut atsat.",
        "translation": "Then go and get those berries."
    },
    "112": {
        "startTime": 823.149,
        "endTime": 831.999,
        "transcript": "Wall'u yuk ikayungqerquni tua-i unicivkenani piarkauluni.",
        "translation": "Or if a person has help, they will not leave any behind."
    },
    "113": {
        "startTime": 832.006,
        "endTime": 844.506,
        "transcript": "Cali atsaungraata tamaani-am yuilqumi amllengraata pitsaqutmek tutmarluki pisqevkenaki makut salmonberries-aat tan'gerpiit-llu.",
        "translation": "Also, even if there are a lot of berries in the wilderness, they were told not to intentionally stop on these salmonberries [cloudberries] and crowberries."
    },
    "114": {
        "startTime": 844.513,
        "endTime": 847.813,
        "transcript": "Tau͡gaam amlliurluki avitaalriacetun.",
        "translation": "Instead, step over them as if avoiding them."
    },
    "115": {
        "startTime": 847.832,
        "endTime": 852.782,
        "transcript": "Tua-i ilii pinritsaange'rmi amllessiyaagqameng tutmalaraput.",
        "translation": "Though one may try not to, we step on them when they're too many."
    },
    "116": {
        "startTime": 852.789,
        "endTime": 859.526,
        "transcript": "Cali imkut naunraat nertukput wangkuta",
        "translation": "Also, those plants that we eat"
    },
    "117": {
        "startTime": 859.539,
        "endTime": 872.526,
        "transcript": "Quagcit, quagcit, angukaat-llu, napat-llu akuliitni atsat",
        "translation": "Sourdock, sourdock, and wild rhubarb, and berries among trees"
    },
    "118": {
        "startTime": 872.539,
        "endTime": 882.376,
        "transcript": "Tamaa-i cali nallullikci ilait, mercuullugpiit, agautaat, atsaanglluut.",
        "translation": "You probably don't know some of them, high-bush cranberries, red currants, black currants."
    },
    "119": {
        "startTime": 882.389,
        "endTime": 887.151,
        "transcript": "Tua-i cali tamaa-i tamakut iqvatukeput napat iluatnek.",
        "translation": "We also pick those berries from trees."
    },
    "120": {
        "startTime": 887.164,
        "endTime": 890.839,
        "transcript": "Tau͡gaam inerquutnguluteng-am ilait.",
        "translation": "However, some are admonished against."
    },
    "121": {
        "startTime": 891.033,
        "endTime": 896.795,
        "transcript": "Nallullikten tayima tulukaruut atsaitnek neqaitnek.",
        "translation": "You probably don't know baneberries."
    },
    "122": {
        "startTime": 896.808,
        "endTime": 902.933,
        "transcript": "Waten tua-i plant-aq atsarugarnek nevumaluni waten kavirpak.",
        "translation": "This plant has many berries clinging to it, and is red."
    },
    "123": {
        "startTime": 902.939,
        "endTime": 905.564,
        "transcript": "Tua-i-gguq tulukaruut neqait.",
        "translation": "They call those \"crow's food [baneberries].\""
    },
    "124": {
        "startTime": 905.583,
        "endTime": 909.858,
        "transcript": "Nerkumteki tamakut naulluqertarkauluta.",
        "translation": "If we eat those, we will get sick."
    },
    "125": {
        "startTime": 909.864,
        "endTime": 923.239,
        "transcript": "Cali yuilqumi imkut inerquutnguluteng neresqevkenaki kanaqliit neqait, uquutvaguanek-wa pilaqeput.",
        "translation": "Also, we are admonished against eateng that thing muskrats eat in the wilderness, what we call poison water hemlocks."
    },
    "126": {
        "startTime": 923.258,
        "endTime": 927.52,
        "transcript": "Tuqunaqluteng tua-i poison-aaruluteng tamakut.",
        "translation": "Those are deadly, poisonous."
    },
    "127": {
        "startTime": 928.108,
        "endTime": 937.046,
        "transcript": "Cali tua-i tamaa-i tamakut mulngakluki irniamteńun apertualuki assiiluciat.",
        "translation": "Being careful with those, we should point out to our children that they're bad."
    },
    "128": {
        "startTime": 937.059,
        "endTime": 943.696,
        "transcript": "Cat-llu tua-i tamakut naunraat neryunarqellriit cali apertualuki.",
        "translation": "We should also point out those plants that are edible."
    },
    "129": {
        "startTime": 944.809,
        "endTime": 950.684,
        "transcript": "Ikiituut tuaten tamakut tamaa-i nertukput",
        "translation": "Even those wild celeries that we eat"
    },
    "130": {
        "startTime": 950.69,
        "endTime": 956.653,
        "transcript": "Cuassaaryaraput-llu makut Kass'at apqaitnek spinach",
        "translation": "And how we eat greens, what they call spinich in English"
    },
    "131": {
        "startTime": 956.665,
        "endTime": 965.828,
        "transcript": "Tua-i allakarmeng-am nunamek teguyarauluteng, ciilqaat tuaten tamaa-i tamakut.",
        "translation": "They have different ways of gathering from the land, including those fireweeds."
    },
    "132": {
        "startTime": 965.84,
        "endTime": 970.14,
        "transcript": "Makut-llu napat cuyait naugaararqata",
        "translation": "Also, when the leaves of these trees newly growing"
    },
    "133": {
        "startTime": 970.159,
        "endTime": 977.009,
        "transcript": "Cali imkut tegg'ivailgata nerluki.",
        "translation": "Also eat those before they get hard."
    },
    "134": {
        "startTime": 977.016,
        "endTime": 984.616,
        "transcript": "Tua-i unatminek cayugluni nerluki, tua-i egmian tamualuki nerluki imkut",
        "translation": "Pull those out with your hands and eat them, chew them immediately and eat them."
    },
    "135": {
        "startTime": 985.473,
        "endTime": 989.623,
        "transcript": "Tamakut assirluteng naugaararqameng.",
        "translation": "Those are good when they're newly grown."
    },
    "136": {
        "startTime": 989.63,
        "endTime": 993.417,
        "transcript": "Tua-i tamakut nertukput naunraat tamakut.",
        "translation": "Those are the plants we eat."
    },
    "137": {
        "startTime": 993.43,
        "endTime": 997.492,
        "transcript": "Ilait-wa tua-i nallunrilketen cat naunraat.",
        "translation": "You probably know some plants."
    },
    "138": {
        "startTime": 997.505,
        "endTime": 1001.455,
        "transcript": "Nallunritlikten cat.",
        "translation": "You probably know some things."
    },
    "139": {
        "startTime": 1003.149,
        "endTime": 1008.574,
        "transcript": "Imkut wiinga nalluanka ilait.",
        "translation": "I don't know some of them."
    },
    "140": {
        "startTime": 1008.58,
        "endTime": 1017.718,
        "transcript": "Makut-am tua-i imkut, imkut water lily-nek pitukait Yugtun im' caulriit?",
        "translation": "What are the things they call water lilies in Yup'ik again?"
    },
    "141": {
        "startTime": 1019.281,
        "endTime": 1023.218,
        "transcript": "Wiinga-w' au͡gna qitevtellren taringenrilkeka.",
        "translation": "I didn't understand what you just said in English."
    },
    "142": {
        "startTime": 1023.981,
        "endTime": 1031.118,
        "transcript": "Imkut nauw' cuyarpalget nanvani kuiguani-llu pugtalriit.",
        "translation": "You know, those things with large leaves that float in lakes and oxbow lakes."
    },
    "143": {
        "startTime": 1031.131,
        "endTime": 1035.943,
        "transcript": "Imkut-qaa? Canek ima tanem pitukait?",
        "translation": "Those things? What do they call them again?"
    },
    "144": {
        "startTime": 1035.956,
        "endTime": 1038.831,
        "transcript": "Nallunricaaqanka. (Nallunaicaaquq-am atra.)",
        "translation": "I know them. (Its name is obvious.)"
    },
    "145": {
        "startTime": 1039.062,
        "endTime": 1040.462,
        "transcript": "Paparnat pilliut?",
        "translation": "Might be paparnat."
    },
    "146": {
        "startTime": 1040.469,
        "endTime": 1041.381,
        "transcript": "Paparnat.",
        "translation": "Paparnat."
    },
    "147": {
        "startTime": 1041.394,
        "endTime": 1045.894,
        "transcript": "Tua-i tang tamakut atutaciit wii nallukenka.",
        "translation": "I don't know how those are used."
    },
    "148": {
        "startTime": 1045.901,
        "endTime": 1047.776,
        "transcript": "Wii-ll' nalluanka.",
        "translation": "I don't know either."
    },
    "149": {
        "startTime": 1047.795,
        "endTime": 1052.382,
        "transcript": "Tua-i au͡gkut ava-i waten ilait umyuaqekenka qanrutkanka plant-at.",
        "translation": "I spoke of some of the plants that I remember."
    },
    "150": {
        "startTime": 1052.395,
        "endTime": 1055.457,
        "transcript": "Ilaqerciqan au͡gna qanellra?",
        "translation": "Will you add to what he said?"
    },
    "151": {
        "startTime": 1055.47,
        "endTime": 1056.683,
        "transcript": "Carrarmek ilaqernaurqa.",
        "translation": "Let me add a little."
    },
    "152": {
        "startTime": 1056.695,
        "endTime": 1057.708,
        "transcript": "Ii-i.",
        "translation": "Okay."
    },
    "153": {
        "startTime": 1057.72,
        "endTime": 1065.37,
        "transcript": "Tua-i-wa ava-i makut-llu naunraat ilakekai uum kalikam ilaunelnguut",
        "translation": "What [he said] just now are part of the plants in this paper"
    },
    "154": {
        "startTime": 1065.377,
        "endTime": 1070.164,
        "transcript": "Naunraat-llu tua-i makut pillret cali, makut-llu.",
        "translation": "And these plants just spoke of, and these."
    },
    "155": {
        "startTime": 1070.177,
        "endTime": 1078.677,
        "transcript": "Ca tua-i, anagulluki uitaarkauluki cumerrnarqellrunritut wangkuta nallemteńi",
        "translation": "Something, they didn't need an excessive amount, and we didn't need to gather a lot in our time"
    },
    "156": {
        "startTime": 1078.696,
        "endTime": 1088.446,
        "transcript": "Caanguaruarkaq tua-i, caanguaruarkaukan amllessiyaakan caanguaruciqngami ilii unakellemta.",
        "translation": "What would be wasted, if it's going to be wasted if it's too much, some of what we obtained would be wasted."
    },
    "157": {
        "startTime": 1088.565,
        "endTime": 1100.203,
        "transcript": "Tau͡gaam tua-i engelqerrluta cumertecetullruitkut tua-i egtarkaunrilngurmek nang'arkamteńek.",
        "translation": "They would only have us gather what was suitable for us, what wouldn't be thrown away, and that we would finish."
    },
    "158": {
        "startTime": 1100.216,
        "endTime": 1104.703,
        "transcript": "Yuilquq-wa tua-i qigcikngamegteggu yuut imkut",
        "translation": "It's because people back then respected the wilderness"
    },
    "159": {
        "startTime": 1104.716,
        "endTime": 1111.166,
        "transcript": "Cat-llu piyarameng nunait tua-i ava-i qanllemtun qigcikngamegteggu.",
        "translation": "And they respected the areas where they subsisted as I just said."
    },
    "160": {
        "startTime": 1111.185,
        "endTime": 1119.785,
        "transcript": "Amlleriluku call' ciptarkauluku pivakaasqessuitellruat wangkutnun.",
        "translation": "They told us not to gather too much that would become surplus."
    },
    "161": {
        "startTime": 1119.792,
        "endTime": 1124.904,
        "transcript": "Tegussiyaagesqessuitellruat ciptarkauluku.",
        "translation": "They said not to take what would become surplus."
    },
    "162": {
        "startTime": 1125.155,
        "endTime": 1130.23,
        "transcript": "Tua-i-w' alinguqelriatun yuilquq yuilqurrung[raan].",
        "translation": "It was like they feared the wilderness, though it was wilderness."
    },
    "163": {
        "startTime": 1144.931,
        "endTime": 1154.306,
        "transcript": "Nallunginanemni akwaugaq qanercuuterlua, qanercuuterlua qanrutaatnga qalarutesqelluten.",
        "translation": "When I didn't expect it, they told me over the phone to speak with you."
    },
    "164": {
        "startTime": 1154.562,
        "endTime": 1155.812,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "165": {
        "startTime": 1155.819,
        "endTime": 1157.369,
        "transcript": "Quyaqerlua waniwa.",
        "translation": "I'm happy now."
    },
    "166": {
        "startTime": 1158.676,
        "endTime": 1159.763,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "167": {
        "startTime": 1159.776,
        "endTime": 1168.538,
        "transcript": "Ingkut piyaaqaatnga Ayalpiim Ayalpigmun neryartullemni",
        "translation": "Over there, Ayalpik told me when I went to go eat at Ayalpik's"
    },
    "168": {
        "startTime": 1171.364,
        "endTime": 1181.126,
        "transcript": "Cat, pit-wa elitnaurat qanrutqaasqelluki piyaaqaatnga",
        "translation": "They told me to speak to the students"
    },
    "169": {
        "startTime": 1181.314,
        "endTime": 1184.689,
        "transcript": "Tau͡gaam qanrutenritanka.",
        "translation": "But I didn't speak to them."
    },
    "170": {
        "startTime": 1190.195,
        "endTime": 1193.045,
        "transcript": "Qanrutevkenaki pianka.",
        "translation": "I didn't speak to them."
    },
    "171": {
        "startTime": 1193.814,
        "endTime": 1199.627,
        "transcript": "Una wani, nuu tegunrilengraan, canrituq. Uum wani tarenrairitem pissuu[tekaa].",
        "translation": "This, no, don't take it, it's okay. It's for the camera here."
    },
    "172": {
        "startTime": 1200.302,
        "endTime": 1207.352,
        "transcript": "Ayagnirluten tua-i wani qanengssaarluten.",
        "translation": "Start by telling a story."
    },
    "173": {
        "startTime": 1207.534,
        "endTime": 1215.746,
        "transcript": "Tua-i waniw' tua-i-w' qanerlua piqatartua.",
        "translation": "Now, I'm going to speak."
    },
    "174": {
        "startTime": 1216.259,
        "endTime": 1227.584,
        "transcript": "Waniwa tua-i pisqumallratni qanengssaarqatartua ellangellemnek.",
        "translation": "As they've asked me to, I'm going to tell a story of my earliest memories."
    },
    "175": {
        "startTime": 1227.59,
        "endTime": 1231.49,
        "transcript": "Ellangellemnek qanengssauteqataranka.",
        "translation": "I'm going to tell them about my earliest memories."
    },
    "176": {
        "startTime": 1231.509,
        "endTime": 1242.572,
        "transcript": "Tua-i alerquutekellrit-llu qanrutekluki piciqanka.",
        "translation": "I will also talk about their traditional instructions."
    },
    "177": {
        "startTime": 1242.584,
        "endTime": 1247.734,
        "transcript": "Ayagyuani, wall'u nasaurlurni...",
        "translation": "Young men, or girls..."
    },
    "178": {
        "startTime": 1248.028,
        "endTime": 1249.253,
        "transcript": "Now go.",
        "translation": "Now go."
    },
    "179": {
        "startTime": 1249.272,
        "endTime": 1251.434,
        "transcript": "Nutaan-qaa? (Yaa.) Yaa.",
        "translation": "Now? (Yes.) Okay."
    },
    "180": {
        "startTime": 1251.447,
        "endTime": 1265.66,
        "transcript": "Tan'gaurlurni nasaurlurni-llu niicugnisqelluci alerquutek'lallemteńek miklemteńi, wiinga-llu tan'gaurlullraullemni.",
        "translation": "Boys and girls, I want you to listen to our traditional instructions when we were small, and when I was a little boy."
    },
    "181": {
        "startTime": 1265.672,
        "endTime": 1275.435,
        "transcript": "They used to instruct us first and foremost to love.",
        "translation": "They used to instruct us first and foremost to love."
    },
    "182": {
        "startTime": 1275.447,
        "endTime": 1283.422,
        "transcript": "Kenka Bible-aani-llu maa-i uitaluni alerquutekluku, kenkulluta pisqelluta.",
        "translation": "Love is in the Bible as an instruction, that we should love one another."
    },
    "183": {
        "startTime": 1283.728,
        "endTime": 1285.728,
        "transcript": "Look at that.",
        "translation": "Look at that."
    },
    "184": {
        "startTime": 1285.747,
        "endTime": 1294.885,
        "transcript": "Tamakut tau͡gken ellangvikellrenka arnat, arnassagaat, angukara'urluut",
        "translation": "However, the women, old women, old men in my earliest memories"
    },
    "185": {
        "startTime": 1294.898,
        "endTime": 1304.023,
        "transcript": "Tua-i canek avaqliinateng, Bible-aanek-llu nalluluteng",
        "translation": "Without anything around them, and not knowing the Bible"
    },
    "186": {
        "startTime": 1304.029,
        "endTime": 1315.904,
        "transcript": "Tau͡gken maa-i Bible-aani igausngalriit tamalkuita alerquutekluki inerquutekluki-llu.",
        "translation": "Yet they instructed and admonished against everything that was written in the Bible."
    },
    "187": {
        "startTime": 1316.748,
        "endTime": 1324.435,
        "transcript": "Tua-i waniwa una ciuqliulria, ciuqliq'lallrat kenkulluta pisqelluta",
        "translation": "This is the first, the first [instruction], to love one another"
    },
    "188": {
        "startTime": 1325.823,
        "endTime": 1328.635,
        "transcript": "Umyuaqsunarqelria.",
        "translation": "Something we should remember."
    },
    "189": {
        "startTime": 1328.923,
        "endTime": 1342.31,
        "transcript": "Qanruyutmikun nangertellria tan'gaurluq wall' nasaurluq elluarrluni pituuq, elluarrluni nangertetuuq.",
        "translation": "A boy or girl who stands with the traditional wisdom passed down to them does well, stands in the right."
    },
    "190": {
        "startTime": 1342.323,
        "endTime": 1355.235,
        "transcript": "However, one who forgets, doesn't follow, or practice the traditional wisdom passed down to them",
        "translation": "However, one who forgets, doesn't follow, or practice the traditional wisdom passed down to them"
    },
    "191": {
        "startTime": 1357.623,
        "endTime": 1364.036,
        "transcript": "Apqiitnek tamakut tuc'inerlualuni-llu pituuq.",
        "translation": "(S)he gets in to what they call [?bad spots]."
    },
    "192": {
        "startTime": 1364.048,
        "endTime": 1371.673,
        "transcript": "Ilaminek, ilaminek, yuullgutminek cangakuurterluni.",
        "translation": "Their peers, those around them, their fellow people criticize them."
    },
    "193": {
        "startTime": 1374.367,
        "endTime": 1379.779,
        "transcript": "Tua-i tangerrluku cangakaqluku.",
        "translation": "They look at their [character] and criticize them."
    },
    "194": {
        "startTime": 1380.53,
        "endTime": 1387.78,
        "transcript": "Pivkenaku tua-i, mulngakevkenaku-llu ilaita pituluku.",
        "translation": "And some don't hold back with them."
    },
    "195": {
        "startTime": 1389.124,
        "endTime": 1398.774,
        "transcript": "Tau͡gken tuaten maligtaquurautellria, qanruyutminek-llu umyuaqilria tuaten piyuitaat.",
        "translation": "However, they don't do that to an obedient person, and one who remembers their traditional wisdom."
    },
    "196": {
        "startTime": 1398.781,
        "endTime": 1404.568,
        "transcript": "Uputaartaituq. Uputaartaituq.",
        "translation": "There's no one speaking unfavorably. There's no one speaking unfavorably."
    },
    "197": {
        "startTime": 1404.818,
        "endTime": 1410.606,
        "transcript": "Tamarmeng yuullgutain naklekaat.",
        "translation": "All of their fellow people treat them with compassion."
    },
    "198": {
        "startTime": 1413.106,
        "endTime": 1422.231,
        "transcript": "Tau-i maa-i mat'um nalliini",
        "translation": "Now, these days"
    },
    "199": {
        "startTime": 1422.25,
        "endTime": 1430.987,
        "transcript": "Tamakut qanruyutet, niiteksaitelaranka-w' tua-i.",
        "translation": "I don't hear those pieces of traditional wisdom."
    },
    "200": {
        "startTime": 1431.337,
        "endTime": 1446.862,
        "transcript": "Tau͡gaam qalartellrianek, qalartellrianek uuggun KYUK-kun niitelaranka tua-i tamakut imkut qanruyutekelput.",
        "translation": "But I've heard those pieces of traditional wisdom passed down to us through people speaking here on KYUK."
    },
    "201": {
        "startTime": 1447.718,
        "endTime": 1455.768,
        "transcript": "Nunat allakaqtaarluteng uitang'e'rmeng atauciq qanruyutekaat",
        "translation": "Though villages stay separate, they speak of one traditional wisdom"
    },
    "202": {
        "startTime": 1455.787,
        "endTime": 1461.825,
        "transcript": "Tuaten kenkulluta, kenka una ciuqliqluku.",
        "translation": "That we should love one another, to put love first."
    },
    "203": {
        "startTime": 1461.825,
        "endTime": 1472.763,
        "transcript": "Inerquutait-wa angurrluk' camek teguqautesqevkenata pikenrilkemteńek, apqemteńek teglegluta.",
        "translation": "Their admonishment was that we should never take what's not ours, what we call stealing."
    },
    "204": {
        "startTime": 1472.776,
        "endTime": 1476.488,
        "transcript": "Tamana inerquutekqapiararaat.",
        "translation": "They strongly admonished against that."
    },
    "205": {
        "startTime": 1476.664,
        "endTime": 1486.651,
        "transcript": "Tuamta-llu alerquutait, maa-i makut piqrartanrilrianek aterpagtelalteng.",
        "translation": "Then their instructions concerning these people whom they called decrepit."
    },
    "206": {
        "startTime": 1486.664,
        "endTime": 1495.026,
        "transcript": "Makut tarranqeggialilriit piqrartanrilrianek aterpagtelallruit.",
        "translation": "They would call those who are no longer active and healthy, decrepit."
    },
    "207": {
        "startTime": 1497.302,
        "endTime": 1503.964,
        "transcript": "Quyavkangnaqu'urluki, quyavkangnaqu'urluki tau͡gaam pisqelluki.",
        "translation": "They were told to try to make them feel only gratitude."
    },
    "208": {
        "startTime": 1506.952,
        "endTime": 1513.952,
        "transcript": "Angurrluk' cangayuutekaatnek wall'u ilutequtekaatnek pisqevkenaki.",
        "translation": "They said to never make them feel offended or sad."
    },
    "209": {
        "startTime": 1513.971,
        "endTime": 1522.296,
        "transcript": "Tau͡gaam quyavkangnaqu'urluki qurrutait ciqilluki, wall'u mertarluteng.",
        "translation": "Instead, try to make them feel happy by duming their honey buckets, or hauling water."
    },
    "210": {
        "startTime": 1522.602,
        "endTime": 1526.715,
        "transcript": "Tua-i tamaa-i alerquutek'lallrit.",
        "translation": "Those were their traditional instructions."
    },
    "211": {
        "startTime": 1526.727,
        "endTime": 1532.677,
        "transcript": "Camek tauna wani kangingqerta tuaten alerquutek'lallrat? Camek kangililartatgu?",
        "translation": "What the meaning of that instruction? What meaning to they ascribe to it?"
    },
    "212": {
        "startTime": 1532.696,
        "endTime": 1543.171,
        "transcript": "Tua-i akaarnun-gguq quyavkarilria maktauraqerciquq.",
        "translation": "They said those who make others happy will stand for a long time."
    },
    "213": {
        "startTime": 1543.177,
        "endTime": 1547.777,
        "transcript": "Unguvauraqerciquq erneq aipirluku.",
        "translation": "He will live for another day for a long time."
    },
    "214": {
        "startTime": 1547.796,
        "endTime": 1556.796,
        "transcript": "Tamaa-i tuaten quyavkarilriim aturtiin iqua.",
        "translation": "That's the outcome for one who practices making others happy."
    },
    "215": {
        "startTime": 1557.09,
        "endTime": 1564.778,
        "transcript": "Maktauraqerciquq-gguq, erneq aipirluku unguvaluni.",
        "translation": "They said he will stand for a long time, living to see another day."
    },
    "216": {
        "startTime": 1565.716,
        "endTime": 1569.103,
        "transcript": "Tuaten nalqigtelallruat.",
        "translation": "That's how they explained it."
    },
    "217": {
        "startTime": 1572.878,
        "endTime": 1575.903,
        "transcript": "Qanruyutait amllertut.",
        "translation": "They have a lot of traditional wisdom."
    },
    "218": {
        "startTime": 1575.922,
        "endTime": 1587.047,
        "transcript": "Tang cuqyucirluteng-llu qalartelallruut, canek imkunek makunek nallunrilkemteńek cuqyucirluteng.",
        "translation": "You see, they also used to speak in metaphors, using these things we know as metaphors."
    },
    "219": {
        "startTime": 1592.716,
        "endTime": 1598.528,
        "transcript": "Pivakarluta kiagmi, kiagmi",
        "translation": "One time in the summer"
    },
    "220": {
        "startTime": 1600.741,
        "endTime": 1611.866,
        "transcript": "Neqcuarmek pugqalriamek tanglartukut, pugqangraan-llu elitaqevkenaku, caucingevkenaku.",
        "translation": "We see fish appearing, and we don't recognize them or know what they are though they appear."
    },
    "221": {
        "startTime": 1611.885,
        "endTime": 1618.847,
        "transcript": "Tua-i cali tauna cuqyutek'lallrat ayuqestassiigutekluku.",
        "translation": "They would also use that as a metaphor, a parable."
    },
    "222": {
        "startTime": 1622.198,
        "endTime": 1637.085,
        "transcript": "Tua-i-gguq ilaminek cangayugcetaarilriim, wall'u iluteqevkaraqluki, wall'u temciarautekluki pilriim",
        "translation": "They say that one who offends those around them, or makes them sad, or makes fun of them"
    },
    "223": {
        "startTime": 1637.098,
        "endTime": 1641.91,
        "transcript": "Unguvallran tua-i kangia.",
        "translation": "The meaning [of that metaphor] is their lifespan."
    },
    "224": {
        "startTime": 1641.923,
        "endTime": 1650.923,
        "transcript": "Unguvallran taktacia neqcuartun pugqalriamun, pugqalriatun elitaqumavkenani.",
        "translation": "The length of their life is not recognizable like the fish that appeared."
    },
    "225": {
        "startTime": 1650.93,
        "endTime": 1659.542,
        "transcript": "Aling ikgepaa tuaten unguvam taktaciani.",
        "translation": "Oh my, how little is the length of that life."
    },
    "226": {
        "startTime": 1660.905,
        "endTime": 1668.055,
        "transcript": "Narurcilriim unguvallran taktacia neqcuartun pugqalriatun.",
        "translation": "The lifespan of one who disobeys wisdom is like the fish that appeared."
    },
    "227": {
        "startTime": 1668.632,
        "endTime": 1679.632,
        "transcript": "Cali aiparluni muragmek.",
        "translation": "There's an accompanying one, wood."
    },
    "228": {
        "startTime": 1679.889,
        "endTime": 1689.014,
        "transcript": "Pivakarluta murakegtaar man'a pilartuq, qainga tua-i man'a assirluni.",
        "translation": "Sometimes, there are good pieces of wood, with its surface looking good."
    },
    "229": {
        "startTime": 1689.42,
        "endTime": 1694.27,
        "transcript": "Sanqeggluni waten. Assirluni tua-i.",
        "translation": "It's straight like this. It's good."
    },
    "230": {
        "startTime": 1695.177,
        "endTime": 1706.989,
        "transcript": "Tua-i tau͡gken ilua, ilua qipqapiarluni qupesciiganani, muriim tamatum.",
        "translation": "The inside of that piece of wood, however, is very twisted and can't be split."
    },
    "231": {
        "startTime": 1707.315,
        "endTime": 1719.765,
        "transcript": "Tua-i-gguq cinatalriim, ciknalriit ilateng pisqumavkenaki pitulliniut.",
        "translation": "Say that that jealous people who do not root for those around them are [like that]."
    },
    "232": {
        "startTime": 1719.997,
        "endTime": 1727.472,
        "transcript": "Tuaten ayuqetulliniut ciknatalriit ilateng pisqumavkenaki.",
        "translation": "Jealous people who don't root for those around them are like that."
    },
    "233": {
        "startTime": 1727.916,
        "endTime": 1740.116,
        "transcript": "Ellait, ellait kiimeng tamakunek canek-wa tua-i pingqerrsugluteng, ilateng pisqumavkenaki.",
        "translation": "They only want those things for themselves, not for those around them."
    },
    "234": {
        "startTime": 1740.198,
        "endTime": 1750.01,
        "transcript": "Tua-i-gguq tuaten umyugaa, qamna umyugaa ayuquq qipelriatun.",
        "translation": "They say that their mind, their mind inside is like the twisted piece of wood."
    },
    "235": {
        "startTime": 1750.023,
        "endTime": 1753.548,
        "transcript": "Ilani kenkevkanki.",
        "translation": "They don't love those around them."
    },
    "236": {
        "startTime": 1754.654,
        "endTime": 1757.654,
        "transcript": "Qipelriatun ayuqluni.",
        "translation": "They're like a twisted piece of wood."
    },
    "237": {
        "startTime": 1760.798,
        "endTime": 1768.048,
        "transcript": "Ayuqestassiiguciraluteng qanrut'lallruitkut tua-i",
        "translation": "They would instruct us through parables"
    },
    "238": {
        "startTime": 1771.617,
        "endTime": 1780.405,
        "transcript": "Tamakunek tamaa-i tamakut angukara'urluut arnarkara'urluut-llu.",
        "translation": "Those things, those old men and old women [would teach us]."
    },
    "239": {
        "startTime": 1783.03,
        "endTime": 1797.305,
        "transcript": "Cali arnarkara'urluut nasaurluut aglellrurtellriit neviarca'rnek pituit, aterpaggluki.",
        "translation": "Also, the old women would refer to the girls who've had their first menstruations as young ladies."
    },
    "240": {
        "startTime": 1797.324,
        "endTime": 1801.574,
        "transcript": "Makut-wa agleryugnailnguut nasaurluut.",
        "translation": "Those who haven't menstruated yet were girls."
    },
    "241": {
        "startTime": 1801.581,
        "endTime": 1806.056,
        "transcript": "Cali-ll' tan'gaurluut makut mikellriit.",
        "translation": "And these small [males] were called boys."
    },
    "242": {
        "startTime": 1806.075,
        "endTime": 1812.712,
        "transcript": "Nulirturniaralria-ll' yun'erra'armek, yun'erra'armek aterpagluku.",
        "translation": "And they called one who was almost ready to take a wife, a young man."
    },
    "243": {
        "startTime": 1812.837,
        "endTime": 1817.35,
        "transcript": "Tamaa-i qalarut'lallruit.",
        "translation": "They would instruct them."
    },
    "244": {
        "startTime": 1817.362,
        "endTime": 1826.687,
        "transcript": "Qalarulluki tua-i ayuqucirkaatnek, ayuqucirkaat apertualuku.",
        "translation": "They would instruct them on proper behavior, pointing out proper behavior."
    },
    "245": {
        "startTime": 1828.218,
        "endTime": 1840.831,
        "transcript": "Umyuaqilriim, umyuaqestiita tamakut, qanruyutmeggnek umyuaqilriit elluarrluteng pituut.",
        "translation": "One who remembers, those who remember, those who remember traditional wisdom live right."
    },
    "246": {
        "startTime": 1841.018,
        "endTime": 1845.168,
        "transcript": "Tua-i, tua-i elluarrluteng.",
        "translation": "They [live] well."
    },
    "247": {
        "startTime": 1845.649,
        "endTime": 1854.024,
        "transcript": "Elluarrluteng nangertetuut, ilameggnek uputaartaunateng.",
        "translation": "They stand in the right, and those around them do not speak unfavorably of them."
    },
    "248": {
        "startTime": 1854.03,
        "endTime": 1864.105,
        "transcript": "Ilameggnek cangakestaunateng qanruyuteteng, qanruyutem mat'um aturtai.",
        "translation": "Those around them do not criticize them, those who practice traditional wisdom."
    },
    "249": {
        "startTime": 1864.124,
        "endTime": 1866.886,
        "transcript": "Tuaten ayuqluteng.",
        "translation": "They're like that."
    },
    "250": {
        "startTime": 1867.024,
        "endTime": 1874.712,
        "transcript": "Ekvicuarmiunek kitak' anglillerpenek cali qanemciteqerkut qaillun tamaani ayuq[ellratnek].",
        "translation": "Please tell us about growing up in Eek, what they were like back then."
    },
    "251": {
        "startTime": 1874.725,
        "endTime": 1878.737,
        "transcript": "Ukut Ekvicuarmiut ciin Ekvicuarmiunek pilartatki?",
        "translation": "Why do they call Eek Ekvicuarmiut [People of the Small Cliffs]?"
    },
    "252": {
        "startTime": 1880.275,
        "endTime": 1895.025,
        "transcript": "Maaten, maaten ellangua wani Ekvicuarmiut, Ekvicuaraat ugkut yuilquullruut.",
        "translation": "In my earliest memories, I found that Ekvicuarmiut, [formerly] Ekvicuaraat [Small Cliffs] downriver was wilderness."
    },
    "253": {
        "startTime": 1895.582,
        "endTime": 1899.532,
        "transcript": "Tan'gaurlullraulua tanglangellruanka.",
        "translation": "I started seeing them as a little boy."
    },
    "254": {
        "startTime": 1899.539,
        "endTime": 1905.739,
        "transcript": "Yuilquullruut nunataunateng, yugtaunateng.",
        "translation": "It was a wilderness with no settlements, no people."
    },
    "255": {
        "startTime": 1905.758,
        "endTime": 1915.346,
        "transcript": "Tau͡gaam wani ag'um Iinrayaam anellrani cakmani Iigmun",
        "translation": "But were the Iinrayaq River across there goes out downriver to Eek"
    },
    "256": {
        "startTime": 1916.359,
        "endTime": 1922.721,
        "transcript": "Iigmun-wa tua-i paillgutkaa agna Iinrayaq.",
        "translation": "Iik has the same mouth as Iinrayaq across there."
    },
    "257": {
        "startTime": 1923.121,
        "endTime": 1932.421,
        "transcript": "Taum paiyartuani, paingani-wa nunatangqellruuq Akulirarmiunek aterluteng.",
        "translation": "Close to the mouth, well, at the mouth, there was a village with the name Akilirarmiut."
    },
    "258": {
        "startTime": 1935.865,
        "endTime": 1939.553,
        "transcript": "Aterpagtaqluki Akulirarmiunek.",
        "translation": "They called them Akulirarmiut."
    },
    "259": {
        "startTime": 1939.566,
        "endTime": 1951.853,
        "transcript": "Tua-i taukut tua-i nunalinqigcameng Ekvicuarmiungurtellruut, Ekvicuarmiunguluteng.",
        "translation": "When they relocated, they became Ekvicuarmiut, the village of Eek."
    },
    "260": {
        "startTime": 1951.866,
        "endTime": 1956.653,
        "transcript": "Yuilquullruut ugkut Ekvicuaraat.",
        "translation": "Ekvicuaraat downriver used to be wilderness."
    },
    "261": {
        "startTime": 1956.663,
        "endTime": 1959.988,
        "transcript": "Kia-ll' algacakeksaunaki.",
        "translation": "And no one salvaged them."
    },
    "262": {
        "startTime": 1960.007,
        "endTime": 1967.732,
        "transcript": "Atam nunauruyuciit nunautellrata ayagnera Uyaquq.",
        "translation": "You see, the beginning of when they were established as a village was Uyaquq."
    },
    "263": {
        "startTime": 1971.538,
        "endTime": 1976.226,
        "transcript": "Qaillun taukut wani Ekvicuarmiut nunaurtellrulliniat?",
        "translation": "How was Eek established as a village?"
    },
    "264": {
        "startTime": 1976.239,
        "endTime": 1987.989,
        "transcript": "Tuaten tua-i Uyaquq tauna, nani im'? Maani qavani uitallruyugnarquq.",
        "translation": "Like that, Uyaquq, where was he again? I think he was upriver."
    },
    "265": {
        "startTime": 1989.633,
        "endTime": 2002.883,
        "transcript": "Tua-i-llu anelraulluku ingna pitangqerran",
        "translation": "Then they brought him downriver, since over there, there were, you know"
    },
    "266": {
        "startTime": 2003.665,
        "endTime": 2014.79,
        "transcript": "Moravian-aat uitiita taukut anelrautelluku tuavet.",
        "translation": "Since there were Moravian priests, they had him brought downriver to there."
    },
    "267": {
        "startTime": 2014.809,
        "endTime": 2021.071,
        "transcript": "Cakmani-w' tua-i taukut Akulirarmiut ullagluki.",
        "translation": "He went to Akulirarmiut downriver."
    },
    "268": {
        "startTime": 2021.084,
        "endTime": 2030.547,
        "transcript": "Tua-i-llu tekiucatgu tuaggun nunaliluki, eneliluku Ekvicuarteggun.",
        "translation": "Then when they arrived with him, they made him a house through the Ekvicuar village."
    },
    "269": {
        "startTime": 2030.722,
        "endTime": 2040.822,
        "transcript": "Tua-i-llu taukut Akulirarmiut nugtarrluteng tuavet Ekvicuarmiungurrluteng.",
        "translation": "Then Akulirarmiut relocated there and became Ekvicuarmiut."
    },
    "270": {
        "startTime": 2044.229,
        "endTime": 2054.041,
        "transcript": "Taum tau͡gaam Uyaqum ulliiteng maligutellruut Moravian-aamun tua-i.",
        "translation": "Only when Uyaquq went to them, they followed him to the Moravian church."
    },
    "271": {
        "startTime": 2054.979,
        "endTime": 2063.767,
        "transcript": "Ullaketaangraiceteng piyuitellruyaaqut maligtaqutellruvkenateng.",
        "translation": "Though [the Moravians] would go to them, they wouldn't comply [with the church]."
    },
    "272": {
        "startTime": 2065.13,
        "endTime": 2070.667,
        "transcript": "Yugturinrakun-qaa ellangellruuten wall'u-qaa yuitellrani cali?",
        "translation": "Did you grow up when it became highly populated or when there was few people?"
    },
    "273": {
        "startTime": 2071.642,
        "endTime": 2076.292,
        "transcript": "Tua-i yuit, yuut amllerrallruut.",
        "translation": "There were quite a few people."
    },
    "274": {
        "startTime": 2076.311,
        "endTime": 2080.324,
        "transcript": "Ellangellemni yugyaggallruuq.",
        "translation": "In my earliest memories, there were pretty many people."
    },
    "275": {
        "startTime": 2080.511,
        "endTime": 2084.336,
        "transcript": "Yuut, nunat yugyagaqluteng.",
        "translation": "Villages would have a lot of people."
    },
    "276": {
        "startTime": 2084.342,
        "endTime": 2088.867,
        "transcript": "Tau͡gaam maa-i yuirutut.",
        "translation": "But they're deserted now."
    },
    "277": {
        "startTime": 2089.098,
        "endTime": 2093.773,
        "transcript": "Ukut-llu Qinarmiut yugtairulluteng.",
        "translation": "And Qinarmiut here is now deserted."
    },
    "278": {
        "startTime": 2094.704,
        "endTime": 2102.904,
        "transcript": "Ugkut tau͡gaam Tuntutuliarmiut cataitellret, taukut tau͡gaam tua-i.",
        "translation": "But Tuntutuliar downriver that didn't use to be there are the only ones."
    },
    "279": {
        "startTime": 2102.923,
        "endTime": 2113.948,
        "transcript": "Cali-llu Kuinerrami cali ciuqliit yuk'ellrit Kuinerrarmiungullret nangluteng.",
        "translation": "Also in Quinhagak, the first people who were at Quinhagak are gone."
    },
    "280": {
        "startTime": 2113.954,
        "endTime": 2121.254,
        "transcript": "Cataitellret tau͡gaam tan'gaurluullret-llu cakma Kuinerrami uitaluteng.",
        "translation": "Only those who weren't there and those who were boys live downriver in Quinhagak."
    },
    "281": {
        "startTime": 2123.536,
        "endTime": 2129.161,
        "transcript": "Ilait nunat yuirutut tamaa-i.",
        "translation": "Some villages are now deserted there."
    },
    "282": {
        "startTime": 2129.167,
        "endTime": 2143.08,
        "transcript": "Apruka'armiunek-llu cali nunatangqellruyaaquq ugkut Iigmiut ketiitni, Kusquqviim yaaqsinrilkiini.",
        "translation": "There also used to be the village of Apruka'armiut toward the water from Eek downriver, not far from the Kuskokwim."
    },
    "283": {
        "startTime": 2143.092,
        "endTime": 2149.467,
        "transcript": "Tayima catairutellrunilaraat. Yuirutellruut ak'a.",
        "translation": "They say it's gone now. It's already deserted."
    },
    "284": {
        "startTime": 2153.148,
        "endTime": 2167.873,
        "transcript": "Tamarmeng, tamarmeng nunat yuk'ellrit ciuqvani tua-i ikegliut, ikegliut.",
        "translation": "All of them, all the people who were in the villages in the past are decreasing, decreasing."
    },
    "285": {
        "startTime": 2168.054,
        "endTime": 2171.179,
        "transcript": "Ayagyuallrit tau͡gaam maa-i.",
        "translation": "Now there are only those who were young back then."
    },
    "286": {
        "startTime": 2171.198,
        "endTime": 2182.185,
        "transcript": "Ugkut Napaskiarmiut ayagyuallret tau͡gaam unegkut tua-i yukluki.",
        "translation": "Napaskiak downriver is only popuated downriver by those who were young back then."
    },
    "287": {
        "startTime": 2182.198,
        "endTime": 2185.81,
        "transcript": "Tamakut ciuqliit nangluteng.",
        "translation": "There are no more of those first people."
    },
    "288": {
        "startTime": 2186.636,
        "endTime": 2197.873,
        "transcript": "Uani-llu cali Naparyarrarni ciuqliit cali nangluteng.",
        "translation": "And downriver in Napakiak, there are no more of the first people."
    },
    "289": {
        "startTime": 2199.311,
        "endTime": 2210.948,
        "transcript": "Ayagyuarullret tau͡gaam, tua-i-w' ilait, ilait tau͡gaam ciuqvaarni yuurtellruut.",
        "translation": "Only those who were young, only some of them were born way back then."
    },
    "290": {
        "startTime": 2211.661,
        "endTime": 2215.911,
        "transcript": "Ciuqvaaraugut ilait.",
        "translation": "Some of them are from way back then."
    },
    "291": {
        "startTime": 2216.593,
        "endTime": 2219.443,
        "transcript": "Pitalguteten-qaa tamakut?",
        "translation": "Those the same age as you?"
    },
    "292": {
        "startTime": 2219.462,
        "endTime": 2224.525,
        "transcript": "Pitatenka nangelriit tayima tua-i.",
        "translation": "There are no more who are the same age as me."
    },
    "293": {
        "startTime": 2225.887,
        "endTime": 2234.5,
        "transcript": "Uani tua-i nunamteńi allrakullgutaitua. Nangellruut.",
        "translation": "Downriver in my village, there's no one the same age as me. They're all gone."
    },
    "294": {
        "startTime": 2238.537,
        "endTime": 2240.912,
        "transcript": "Ak'allaunqurrauluten elpet?",
        "translation": "You're the oldest?"
    },
    "295": {
        "startTime": 2240.918,
        "endTime": 2245.568,
        "transcript": "Ii-i, ak'allaunqurraulua tua-i wii kiima.",
        "translation": "Yes, I'm the only oldest one."
    },
    "296": {
        "startTime": 2245.587,
        "endTime": 2252.512,
        "transcript": "Aipaqa-llu-w' imna ama-i emusngauq Anchorage-aami.",
        "translation": "And my spouse went to the hospital over in Anchorage."
    },
    "297": {
        "startTime": 2258.343,
        "endTime": 2267.581,
        "transcript": "Elpet wani umyuarteqlerpeni, cam, cam una erneq tekicetau?",
        "translation": "In your opinion, what has [helped] bring [us] to this day?"
    },
    "298": {
        "startTime": 2267.856,
        "endTime": 2279.256,
        "transcript": "Umyuarteqlemni Agayutem, Agayutem erneq una tekicetaa.",
        "translation": "In my opinion, God has brought this day."
    },
    "299": {
        "startTime": 2279.276,
        "endTime": 2299.276,
        "transcript": "Waniwa qanlartut yuk tuaten ernernek amllertalrianek Agayutmun cikilarniluku atu'urkaitnek yuurtellrani.",
        "translation": "They say that God gives that person a certin number of days to live when they're born."
    },
    "300": {
        "startTime": 2299.283,
        "endTime": 2310.116,
        "transcript": "Tua-i-llu yuk tuaten nangerngaluni, pillerkiuraa-llu tekiskuniu tua-i takarrluni.",
        "translation": "Then that person stands [alive], then when they reach their time, they pass away."
    },
    "301": {
        "startTime": 2310.361,
        "endTime": 2314.077,
        "transcript": "Tamaa-i tamana umyuaqelalqa.",
        "translation": "That's what would be in my mind."
    },
    "302": {
        "startTime": 2315.545,
        "endTime": 2322.561,
        "transcript": "Kiagaqan maa-i wani angyakun ayaganglartut.",
        "translation": "When summer sets now, they start traveling by boat."
    },
    "303": {
        "startTime": 2322.572,
        "endTime": 2336.122,
        "transcript": "Ak'a-llu avani ciuqvani, ciuqvani-wa una erneq tekilluku wangkuta Yugni kit'essuutnek, aipaiput makut wani kit'essuutnek pingut.",
        "translation": "And a long time ago in the past to this day, we Yupiit have started using these life jackets of our [Western] counterparts."
    },
    "304": {
        "startTime": 2337.254,
        "endTime": 2345.204,
        "transcript": "Camek alerquryugngasiki angyaralriit kiagpak murilkellerkaitnek?",
        "translation": "What can you instruct those going boating all summer that they should watch out for?"
    },
    "305": {
        "startTime": 2347.074,
        "endTime": 2356.041,
        "transcript": "Waniwa tua-i tamakut pugtaucilartut yuk puvtavkarluku.",
        "translation": "Now, they have floatation devices to keep a person afloat."
    },
    "306": {
        "startTime": 2356.051,
        "endTime": 2360.926,
        "transcript": "Tamakunek piicunaunani, piicunaicaaqluni.",
        "translation": "One should not be without those."
    },
    "307": {
        "startTime": 2361.557,
        "endTime": 2366.707,
        "transcript": "Uqamaitenrilata-llu ayauqurayunaqluteng.",
        "translation": "And since they're not heavy, they're easy to travel with."
    },
    "308": {
        "startTime": 2369.076,
        "endTime": 2375.989,
        "transcript": "Kiagmi, kiagmi ayagauralalriit maa-i tua-i.",
        "translation": "In the summer, now they always travel in the summer."
    },
    "309": {
        "startTime": 2376.001,
        "endTime": 2382.351,
        "transcript": "Tamaani tau͡gken ciuqvani tamakutaituq kit'essuutnek.",
        "translation": "Back in the past, however, there were none of those life jackets."
    },
    "310": {
        "startTime": 2382.358,
        "endTime": 2388.695,
        "transcript": "Angyakun-llu ayagayuunateng, qayakun tau͡gaam anguarluteng.",
        "translation": "And they wouldn't travel by boat, but row kayaks."
    },
    "311": {
        "startTime": 2389.22,
        "endTime": 2393.008,
        "transcript": "Tamaa-i ayagassuutiit qayaq.",
        "translation": "That was their traveling device, the kayak."
    },
    "312": {
        "startTime": 2393.033,
        "endTime": 2397.996,
        "transcript": "Maa-i tau͡gken angyarluteng levaarluteng.",
        "translation": "Now, however, they have boats and boat motors."
    },
    "313": {
        "startTime": 2398.008,
        "endTime": 2402.608,
        "transcript": "Qaciggluteng tua-i ayagaaqluteng.",
        "translation": "They have an easy time traveling."
    },
    "314": {
        "startTime": 2402.627,
        "endTime": 2412.202,
        "transcript": "Taumek tamakut kit'essuutet tua-i qeleksunarqut.",
        "translation": "That's why you should keep those life jackets."
    },
    "315": {
        "startTime": 2412.233,
        "endTime": 2423.146,
        "transcript": "Now, we know, we now know that a person's potential misfortune is right in front of them.",
        "translation": "Now, we know, we now know that a person's potential misfortune is right in front of them."
    },
    "316": {
        "startTime": 2423.471,
        "endTime": 2437.983,
        "transcript": "Iciwa waniwa-llu angnirluni, engelallagaluni-llu pirraarluni, tua-i-llu ilani unicamiki tayimqerluni.",
        "translation": "You know, after someone is happy, and bursts out laughing, then when they leave their peers, they disappear."
    },
    "317": {
        "startTime": 2437.984,
        "endTime": 2439.646,
        "transcript": "Tang.",
        "translation": "You see?"
    },
    "318": {
        "startTime": 2439.897,
        "endTime": 2448.147,
        "transcript": "Yuum picurlallran nantenrilucia. Tua-i waniw' ciuqerrani uitauq.",
        "translation": "A person's potential for misfortune is always present. It's right in front of them."
    },
    "319": {
        "startTime": 2448.429,
        "endTime": 2463.004,
        "transcript": "Taumek alerquutet makut, makut Kass'at cait cakaarayunaicaaqut.",
        "translation": "That's why you shouldn't forsake these instructions about these Western things."
    },
    "320": {
        "startTime": 2463.023,
        "endTime": 2472.06,
        "transcript": "Tamakut-llu kit'essuutet avaqliqluki. Avaqliqluki uqamaitevkanteng-llu.",
        "translation": "And keep those life jackets with you. And they're not heavy to keep with you."
    },
    "321": {
        "startTime": 2472.373,
        "endTime": 2479.823,
        "transcript": "Aturluki-llu ping'e'rmi atuyunaqluteng pugtat'laamegteki.",
        "translation": "And even when using them, they're easy to use since they keep you afloat."
    },
    "322": {
        "startTime": 2493.505,
        "endTime": 2497.355,
        "transcript": "Maa-i-llu angyakun ayagalallrat",
        "translation": "And traveling with boats now"
    },
    "323": {
        "startTime": 2499.449,
        "endTime": 2502.887,
        "transcript": "Kit'ellrianek niiqurangukut maa-i.",
        "translation": "We always hear about people drowning now."
    },
    "324": {
        "startTime": 2502.887,
        "endTime": 2508.212,
        "transcript": "Qaillun taukuk wani qalarutekniagken.",
        "translation": "Please speak about those."
    },
    "325": {
        "startTime": 2509.531,
        "endTime": 2510.768,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "326": {
        "startTime": 2510.781,
        "endTime": 2519.581,
        "transcript": "Ayuqeltassiigullukek-wa cukanrarluni cukaunani-llu kit'ellrak, kit'elallrak naliak amllenrua, ciin-llu.",
        "translation": "Compare drowning when going fast and slow, which has more drowning incidents, and why."
    },
    "327": {
        "startTime": 2521.588,
        "endTime": 2526.513,
        "transcript": "Kitak' tamana wani qanrutkeqerru.",
        "translation": "Now, please speak about that."
    },
    "328": {
        "startTime": 2529.219,
        "endTime": 2541.919,
        "transcript": "Tamaa-i, tamaa-i tamatum nalliini ayagassuutengqertut qayanek.",
        "translation": "Back in that time, they traveled with kayaks."
    },
    "329": {
        "startTime": 2541.926,
        "endTime": 2554.938,
        "transcript": "Tua-llu anuqengararutaqateng qaspengqerrluteng-llu imkunek maklaaret qiluitnek",
        "translation": "Then when the wind picks up on them, they had light pullover garments made of bearded seal intestines"
    },
    "330": {
        "startTime": 2554.951,
        "endTime": 2560.464,
        "transcript": "Irnerrlugnek qaspernek all'uki pitulinek.",
        "translation": "Seal gut pullovers that they put on."
    },
    "331": {
        "startTime": 2560.464,
        "endTime": 2567.101,
        "transcript": "[Cover] the kayak cockput with that, you know how they're round?",
        "translation": "[Cover] the kayak cockput with that, you know how they're round?"
    },
    "332": {
        "startTime": 2567.114,
        "endTime": 2569.876,
        "transcript": "Qayanek-qaa tanglallruuten? (Yaa.)",
        "translation": "Did you used to see kayaks? (Yes.)"
    },
    "333": {
        "startTime": 2569.889,
        "endTime": 2572.239,
        "transcript": "Iciw' uivenqellriit?",
        "translation": "You know how they're round?"
    },
    "334": {
        "startTime": 2572.258,
        "endTime": 2577.577,
        "transcript": "Kinguqaminek qumigluku qayam painga.",
        "translation": "He would cover the kayak's cockpit with his hem."
    },
    "335": {
        "startTime": 2577.577,
        "endTime": 2586.064,
        "transcript": "Tua-i-llu nutaan pelacinaunrilngurmek tapengyaarmek pinevkarluku piliameggnek nemerluku.",
        "translation": "Then they would bind it with a handmade rope of sealskin."
    },
    "336": {
        "startTime": 2586.077,
        "endTime": 2588.002,
        "transcript": "Tua-i-gguq ket'garluku.",
        "translation": "They called that securing it with a rope."
    },
    "337": {
        "startTime": 2588.021,
        "endTime": 2596.233,
        "transcript": "Tua-i qairem waten pilangraani iterciiganani qayaan iluanun.",
        "translation": "Though waves do this to him, it cannot go in his kayak."
    },
    "338": {
        "startTime": 2596.796,
        "endTime": 2600.821,
        "transcript": "Tuaten pitullruut.",
        "translation": "That's what they did."
    },
    "339": {
        "startTime": 2600.94,
        "endTime": 2606.99,
        "transcript": "Qayaan iluanun iterciiganani meq qumikngani.",
        "translation": "Water cannot go in his kayak because it's in his hem."
    },
    "340": {
        "startTime": 2607.272,
        "endTime": 2616.409,
        "transcript": "Tua-ll' makut wani angyat, kill'uteng-llu piksaitelaryaaqut.",
        "translation": "Then these boats haven't sunk."
    },
    "341": {
        "startTime": 2616.434,
        "endTime": 2628.084,
        "transcript": "Tau͡gaam mat'um, mat'um aturyulallrata, atungnaq'lallrata picurlagavkalarai.",
        "translation": "But this thing they abuse, what they try to abuse brings them to misfortune."
    },
    "342": {
        "startTime": 2628.091,
        "endTime": 2634.341,
        "transcript": "Picurlagatek'larait taangamek aterpagcimalria.",
        "translation": "What's called alcohol is the cause of their misfortune."
    },
    "343": {
        "startTime": 2634.76,
        "endTime": 2639.623,
        "transcript": "Tamakutaitellrani picurlalriartaitellruuq.",
        "translation": "When that didn't exist, no one met with misfortune."
    },
    "344": {
        "startTime": 2639.623,
        "endTime": 2647.485,
        "transcript": "Picurlalriamek niicuitellruukut kiagmi kit'ellriamek.",
        "translation": "We didn't hear of anyone getting into misfortune in the summer, anyone drowning."
    },
    "345": {
        "startTime": 2647.486,
        "endTime": 2659.248,
        "transcript": "Now, every person of the villages don't want their youth to abuse this.",
        "translation": "Now, every person of the villages don't want their youth to abuse this."
    },
    "346": {
        "startTime": 2659.749,
        "endTime": 2663.136,
        "transcript": "Ayagyuanrilnge'rmeng-llu pilalriit.",
        "translation": "Even those who aren't young abuse it."
    },
    "347": {
        "startTime": 2663.149,
        "endTime": 2669.286,
        "transcript": "Kanevtellriatun waten, kanevtellriatun ayuqluki.",
        "translation": "It's like it scatters them [their lives] like this."
    },
    "348": {
        "startTime": 2669.549,
        "endTime": 2674.911,
        "transcript": "Tua-i tuaten wii ayuqekutela'arqa kanevtellriatun.",
        "translation": "That's how I compare it, like scattering them [their lives]."
    },
    "349": {
        "startTime": 2674.949,
        "endTime": 2685.249,
        "transcript": "Iciw' kanevciaqamta tua-i kanvelalria, imna-ll' taryirissutmek pilallerput kanvaqluni.",
        "translation": "You know, when we scatter things, they scatter, and what we call saltshakers scatter [salt]."
    },
    "350": {
        "startTime": 2685.268,
        "endTime": 2699.143,
        "transcript": "Tuarpiaq umyuartequrarqama tuaten tua-i kanvutekluku man'a aturyulallrat.",
        "translation": "It truly seems when I ponder that what they abuse makes their [lives] scatter."
    },
    "351": {
        "startTime": 2699.174,
        "endTime": 2704.543,
        "transcript": "People back then didn't know of any [misfortune] when that didn't exist.",
        "translation": "People back then didn't know of any [misfortune] when that didn't exist."
    },
    "352": {
        "startTime": 2704.543,
        "endTime": 2710.53,
        "transcript": "Tamakutaitellrani picurlagayuunateng.",
        "translation": "When that didn't exist, they wouldn't come to misfortune."
    },
    "353": {
        "startTime": 2710.543,
        "endTime": 2720.743,
        "transcript": "Tuaten tua-i angenricaaqut-ll' au͡gkut ayagassuutek'lallrit. Qayat kiingita ayagassuutait.",
        "translation": "And their means of travel back then weren't big like that. Kayaks were their only means of travel."
    },
    "354": {
        "startTime": 2722.062,
        "endTime": 2732.862,
        "transcript": "Man'a kitak' cali: waten maa-i niiqurangelriakut qanruyutmek, qanruyutet niitnaunrirniluki.",
        "translation": "This one too: now, we always hear that traditional wisdom is not heard anymore."
    },
    "355": {
        "startTime": 2732.869,
        "endTime": 2739.806,
        "transcript": "Elpeni cali murilkellerpeni ciin qanruyutet qanruteknanrirpakartatki ciuliamta?",
        "translation": "In your observation, why don't our elders speak about traditional wisdom too much anymore?"
    },
    "356": {
        "startTime": 2739.806,
        "endTime": 2752.619,
        "transcript": "Tua-i, tua-i au͡gkut, au͡gkut ciuqlimta, ciuqliput nang'ngata.",
        "translation": "It's because the people back then, there are no more of our elders."
    },
    "357": {
        "startTime": 2752.631,
        "endTime": 2766.644,
        "transcript": "Qanruyutet tamakunek ciuqlimteńek qanrutkestairucata qanrutkestairutut.",
        "translation": "Because traditional wisdom had no more of our elders to speak of them, there is no one who speaks of them."
    },
    "358": {
        "startTime": 2768.019,
        "endTime": 2773.981,
        "transcript": "Ilaita-llu nallunrit'laryaaqellikait tayima.",
        "translation": "Some of them probably know about them."
    },
    "359": {
        "startTime": 2774.569,
        "endTime": 2781.688,
        "transcript": "Qanruyun ak'allaq niitelaryaaqellikiit.",
        "translation": "They probably hear of the ancient traditional wisdom."
    },
    "360": {
        "startTime": 2781.688,
        "endTime": 2788.138,
        "transcript": "Tamaa-i qanrutkurtairucami.",
        "translation": "It's because no one speaks about it anymore."
    },
    "361": {
        "startTime": 2788.145,
        "endTime": 2797.957,
        "transcript": "Atam tamakut tamaa-i angullrenka",
        "translation": "Look, the people I was born in time to see"
    },
    "362": {
        "startTime": 2797.958,
        "endTime": 2807.82,
        "transcript": "Qalaruyut'seng cimiqetaarpek'naku atauciq tua-i atauciuluku qalarutkuratuat.",
        "translation": "They would speak of their instruction without changing it, where one was one and the same [every time]."
    },
    "363": {
        "startTime": 2807.833,
        "endTime": 2812.502,
        "transcript": "Uum qalartaqami qanrutkaqluku.",
        "translation": "When this person gave instruction, (s)he would speak of it."
    },
    "364": {
        "startTime": 2812.502,
        "endTime": 2818.439,
        "transcript": "Akaurpailgan allam uum qanraqami qanrutkaqluku.",
        "translation": "Before long, when another gave instruction, (s)he would speak of it."
    },
    "365": {
        "startTime": 2818.452,
        "endTime": 2828.602,
        "transcript": "Tamaa-i tamakunek tegganrurtellrianek qalarutkestairucameng",
        "translation": "Because they don't have those who've become elders to speak of them anymore"
    },
    "366": {
        "startTime": 2828.621,
        "endTime": 2840.409,
        "transcript": "Qanruyun man'a qanrutkuranriraat nang'ngameng tamakut qalarustek'lallri.",
        "translation": "They don't speak about this traditional wisdom because those who spoke of them are almost gone."
    },
    "367": {
        "startTime": 2840.634,
        "endTime": 2848.784,
        "transcript": "Waten, waten cali makut wani ciuliaput waten qanerturalalriit.",
        "translation": "Our elders always give instruction like this."
    },
    "368": {
        "startTime": 2848.791,
        "endTime": 2861.303,
        "transcript": "Qanerturalalriit-wa. Tuar, tuar qanruyutet pinrillrat ayagyuanun elliluku qanrucunairutniluta.",
        "translation": "They give instruction. It seems they place [the blame] on young people, saying that we do not heed advice anymore."
    },
    "369": {
        "startTime": 2861.316,
        "endTime": 2867.366,
        "transcript": "Ciin, ciin tamana cali tuaten piularta maa-i?",
        "translation": "Why is it like that now?"
    },
    "370": {
        "startTime": 2867.385,
        "endTime": 2875.785,
        "transcript": "Tua-i maa-i tang atungekvut tua-i tamana imna qanrutkelallrat.",
        "translation": "Now, you see, we're doing what they spoke of."
    },
    "371": {
        "startTime": 2876.104,
        "endTime": 2879.892,
        "transcript": "Qanrutkelallrat atungekvut.",
        "translation": "We're doing what they spoke of."
    },
    "372": {
        "startTime": 2881.342,
        "endTime": 2886.855,
        "transcript": "Qanqauteng'e'rmi aturciigaliluku.",
        "translation": "The one is given instruction, (s)he cannot practice it."
    },
    "373": {
        "startTime": 2888.442,
        "endTime": 2894.942,
        "transcript": "Niicugnirraarluni tua-i-ll' ayagluni tua-i unilluku.",
        "translation": "After one listens, they go and leave it behind."
    },
    "374": {
        "startTime": 2897.436,
        "endTime": 2906.724,
        "transcript": "Tamaa-i tamana umyuaqluku ilaita pilallruut.",
        "translation": "Some of them would speak with that in mind."
    },
    "375": {
        "startTime": 2906.749,
        "endTime": 2909.562,
        "transcript": "Maa-i tua-i qanrutkelallrat.",
        "translation": "This is what they spoke of."
    },
    "376": {
        "startTime": 2911.499,
        "endTime": 2916.818,
        "transcript": "Qanruyun atunrirciqniluku-ll' wii niigartelallruunga.",
        "translation": "I also used to hear that people would stop practicing traditional wisdom."
    },
    "377": {
        "startTime": 2916.818,
        "endTime": 2927.943,
        "transcript": "Qanrutestairuskata qanruyun atunrirciqniluku avani ciuqvaarni niigartelallruaqa.",
        "translation": "I used to hear way back in the past that when they have no more instructors that they will stop practicing traditional wisdom."
    },
    "378": {
        "startTime": 2930.612,
        "endTime": 2938.387,
        "transcript": "Maa-i-qaa tamana niitelallren elpeni piciurtuq qanruyun atunritellra?",
        "translation": "Now, do you think that what you heard about people not practicing traditional wisdom has come true?"
    },
    "379": {
        "startTime": 2938.393,
        "endTime": 2943.618,
        "transcript": "Ii-i, ii-i, piciurtuq tua-i maa-i.",
        "translation": "Yes, yes, it's come true now."
    },
    "380": {
        "startTime": 2943.649,
        "endTime": 2955.025,
        "transcript": "Tang au͡gkut yaaqvaq-llu tekitarkaq nallunrilngurtun pilallrulliniat.",
        "translation": "You see, it was like people back then knew the far off future."
    },
    "381": {
        "startTime": 2955.025,
        "endTime": 2957.587,
        "transcript": "Nallunrilngurtun.",
        "translation": "It's like they knew."
    },
    "382": {
        "startTime": 2963.888,
        "endTime": 2980.0,
        "transcript": "Camek wani tua-i paiciryullerpenek wangkuta ayagyuani wall'u niicugnilriani camek alerquutmek paicirluta.",
        "translation": "Something that you want to leave with us, what kind of instruction would you leave with us young people or those of us who are listening?"
    },
    "383": {
        "startTime": 2980.001,
        "endTime": 2980.951,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "384": {
        "startTime": 2980.97,
        "endTime": 2983.033,
        "transcript": "Camek paiciryarcikut?",
        "translation": "What would you leave with us?"
    },
    "385": {
        "startTime": 2983.583,
        "endTime": 2988.527,
        "transcript": "Paiciutekaqa paiciuteksugyaaqek'ngaqa.",
        "translation": "I leave with you what I want to leave with you."
    },
    "386": {
        "startTime": 2988.527,
        "endTime": 3000.152,
        "transcript": "Waniwa kenkulluci ayagyualriani, kenkulluci. Ilaci cangayugcetaarpek'naki pisqelluki.",
        "translation": "Now, love each other, young people, love each other. Do not offend those around you."
    },
    "387": {
        "startTime": 3000.183,
        "endTime": 3005.933,
        "transcript": "Ilakelriatun ayuqulluci elpeceńi.",
        "translation": "Be like a family."
    },
    "388": {
        "startTime": 3005.965,
        "endTime": 3021.065,
        "transcript": "Maa-i tang makut wani iqlutmun ayagarcuukarangelria qanruyutni wall'u cangayullni ayagneqluku.",
        "translation": "Now, you see, one easily goes the wrong way when [disobeying] traditional wisdom, or starting from being offended."
    },
    "389": {
        "startTime": 3021.084,
        "endTime": 3028.859,
        "transcript": "Ayuqlutek, ayuqlutek arnaunge'rmi tuaten ayuqliriuq.",
        "translation": "[Men and woman] the same way, even women have become like that."
    },
    "390": {
        "startTime": 3028.865,
        "endTime": 3040.815,
        "transcript": "Cangayuutni iqlutmun ayagarutekarkauluku, iqlutmuqrulluku, iqlutmuqrutekluku.",
        "translation": "They go the wrong way when they are offended, go wrong because of that."
    },
    "391": {
        "startTime": 3041.934,
        "endTime": 3057.584,
        "transcript": "Tau͡gaam waten, waten atam cangayugcetaarpek'naki ilaci, ayagyuallguceci, angutngurtengraan wall' arnaurtengraan ayuqluku piurquvci",
        "translation": "But like this, you see, if you do not try to offend those around you, your fellow youth, or even if they're old men or old women"
    },
    "392": {
        "startTime": 3057.603,
        "endTime": 3065.278,
        "transcript": "Imutun tua-i uqisngauralriun, uqisngauralriatun ayuqniartuci.",
        "translation": "So it'll be like you're in a safe shelter."
    },
    "393": {
        "startTime": 3065.297,
        "endTime": 3074.184,
        "transcript": "Man'a maa-i umyuaqelarniaran catairusnge'rma-llu wii.",
        "translation": "Remember this even when I'm gone."
    },
    "394": {
        "startTime": 3074.222,
        "endTime": 3079.684,
        "transcript": "Ii-i, quyana. Quyana qalangssaulluta.",
        "translation": "Yes, thank you. Thank you for telling us stories."
    },
    "395": {
        "startTime": 3080.797,
        "endTime": 3082.197,
        "transcript": "Yaa.",
        "translation": "You're welcome."
    }
};